import { Controller } from "stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  static values = { printable: Boolean };

  async showDialog(ev) {
    ev.preventDefault();
    let $anchor = ev.currentTarget;
    const labels = JSON.parse($anchor.dataset.printReceiptLabels || '{}');

    const { value: formValues } = await Swal.fire({
      title: labels.title,
      html: `
        <div class="row">
          <div class="col-12">
            <div class="form-group text-left">
              <label>${labels.formatLabel}</label>
              <select class="form-control" name="type" id="swal-format">
                <option value="tax">${labels.formatTax}</option>
                <option value="letter">${labels.formatLetter}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group text-left">
              <label>${labels.copiesLabel}</label>
              <select class="form-control" name="copies" id="swal-copies">
                <option value="1">${labels.copiesCompany}</option>
                <option value="2">${labels.copiesCustomerAndCompany}</option>
              </select>
            </div>
          </div>
        </div>
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: labels.confirm,
      cancelButtonText: labels.cancel,
      preConfirm: () => {
        return {
          type: document.getElementById('swal-format').value,
          copies: document.getElementById('swal-copies').value,
        }
      }
    });

    if (!formValues) {
      return ev.preventDefault();
    }

    let href = $anchor.getAttribute('href');
    href = href.replaceAll('c-type', formValues.type);
    href = href.replaceAll('c-copies', formValues.copies);

    document.querySelector('body').insertAdjacentHTML('beforeEnd', `<a href="${href}" data-turbo-frame="_top" data-turbo="false" target="${$anchor.getAttribute('target')}" id="anchor-to-print-frame"></a>`);
    let anchor = document.querySelector('a#anchor-to-print-frame');
    anchor.click();
    setTimeout(() => anchor.remove(), 500);
  }
}